import axios from "axios";
import router from "@/router/router";
import { useAuthStore } from "../store/useAuthStore";

export default () => {
    const authStore = useAuthStore();

    axios.defaults.baseURL = "/api/v1";
    let instance = axios.create();

    /*
     * Response Interceptor
     */
    instance.interceptors.response.use(
        response => response,
        (error) => {
            if (error.response.status === 401) {
                authStore.clearAuthSession();
                router.push({ name: "login" });
                return Promise.reject(error);
            }
            else if(error.response.status === 403) {
                router.push({ name: "forbidden" });
                return Promise.reject(error);
            }
            // else if(error.response.status === 404) {
            //     router.push({ name: "not-found" });
            //     return Promise.reject(error);
            // }
            else {
                return Promise.reject(error);
            }
        },
    );

    return instance;
};
